import { render, staticRenderFns } from "./TaskPratiche.vue?vue&type=template&id=f17aedc6"
import script from "./TaskPratiche.vue?vue&type=script&lang=js"
export * from "./TaskPratiche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports